import { STORAGE_USER_ID } from "../../constants/localstorage";
import { ROUTE_LOGIN } from "../../constants/routes";
import { memoryHistory } from "../../index";
import { logIn } from "../../libs/auth";
import { getStorage } from "../../libs/storage";
import { UserProfileSetNicknameResponse } from "../../proto/UserProfileSetNickname_pb";
import store from "../../store";
import { updateUser } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";
import Metrix from "../../libs/metrix";
import { METRIX_REGISTER_UNIQUE } from "../../constants/events";

export default class HandleUserProfileSetNicknameResponse extends BaseHandler<UserProfileSetNicknameResponse> {
  handle() {
    const userProfileSetNicknameResponse = this.response.toObject();
    Metrix.sendEvent(METRIX_REGISTER_UNIQUE);
    if (memoryHistory.location.pathname.startsWith(ROUTE_LOGIN)) {
      logIn();
    }
    store.dispatch(
      updateUser({
        userId: getStorage(STORAGE_USER_ID),
        values: {
          initials: userProfileSetNicknameResponse.initials,
          displayName: userProfileSetNicknameResponse.nickname,
        },
      })
    );
  }
}
